module.exports = __webpack_public_path__ + "img/logo.69897f78.png";